/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const TeamsAPI = {
  createTeam: async(teamBody: any) =>
    (await initAxios())
      ?.post('/teams', JSON.stringify(teamBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default TeamsAPI;
